<template>
  <div class="base-wrapper">

    <div class='content-wrapper'>

      <div class="header-content" id="arena-header" v-if="focusTeamData">


        <s3-image width="100" :src="'teams/' + focusTeamData.logo"/>
        <h1>{{focusTeamData.name}}</h1>
        <div class='subheader spread'>
          <!--          <h5>Current Rank: 45</h5>-->
          <h6 v-for="(geo, idx) in focusTeamData.organization_players" :key="geo.name" class="seconday">
            <a :href="'/dashboard/' + geo.parent_name">
              {{geo.name}}
            </a>
          </h6>
        </div>
      </div>
      <div class="uk-section uk-padding-small-top" id="arena-schedule">
        <h2>{{ !playoffs ? "Schedule" : "Playoff Bracket"}}</h2>


        <ul class="uk-tab-bottom" style="max-width: 1000px; margin: auto;" uk-tab>
          <li :class="{'uk-active': focusedDivision === 1 }"><a href="#" @click="focusedDivision=1; playoffs = false">Division
            A</a></li>
          <li :class="{'uk-active': focusedDivision === 2 }"><a href="#" @click="focusedDivision=2; playoffs = false">Division
            B</a></li>
          <li :class="{'uk-active': focusedDivision === 3 }"><a href="#" @click="focusedDivision=3; playoffs = false">Division
            C</a></li>
          <li class="uk-disabled"><a href="#" @click="playoffs=true">Playoff Bracket</a></li>
        </ul>
        <Schedule
                :data="displayedSchedule"
                v-if="!playoffs"
                @teamselected="(team) => getMatchHistory(team)"
        />

        <div class="bracket-wrapper" v-if="playoffs">
          <bracket/>
        </div>
      </div>


      <div class="uk-section uk-padding-remove-top" id="arena-match-results">
        <h2 class="uk-margin-small-bottom"><b>{{matchHistoryFocusTeamDisplayName}}</b> Match History</h2>
        <div>
          <carousel
                  ref="carousel"
                  :per-page="1"
                  v-model="carouselPage"

          >
            <slide v-for="(match, i) in matchHistory" :key="match.round.start">
              <Match
                      :data="match"
                      :game="i+1"
              />
            </slide>
          </carousel>
        </div>
      </div>

      <ul class="uk-tab-bottom" style="max-width: 1000px; margin: auto;" uk-tab>
        <li v-for="(o,i) in orgTypes" :class="{'uk-active':selectedOrgType==o}"><a href="#"
                                                                                   @click="selectedOrgType=o; ">{{o}}</a>
        </li>
      </ul>
      <data-table v-if="orgTypes" :data="orgTypeData(selectedOrgType)"
                  :name="matchHistoryFocusTeamDisplayName"></data-table>
      <spinner v-if="spinner"></spinner>


    </div>

    <Demo showName="arena"></Demo>
  </div>

</template>

<script>


	import Alert from "./theme/Alert.vue"
	import Match from './arena/scoreboard/Match';
	import Bracket from './arena/bracket/Bracket';
	import Schedule from './arena/schedule/Schedule';
	import S3Image from './theme/S3Image';
	import Demo from './theme/Demo'
	import DataTable from './theme/DataTable';
	import Spinner from './theme/Spinner';
	import moment from 'moment';

	import {testmatchhistory, testteamlist} from "@/components/arena/fakedata";
	import apicall from '../store/apicall'


  const a = ["2019-06-24", "2019-07-29", "2019-07-15"]

	const getUserTeam = (context) => {

		const request = {
			"purpose": "get_team", //user auth token to determine
			"parameters": {}
		}

		return apicall.post("/arena/", request)
				.then((res) => {
					console.log("GET USER TEAM REQUEST", res.data)
					context.focusTeam = res.data.abbreviation; //this will be null if there is not team.
					context.focusTeamData = res.data;
					return res.data.abbreviation;
				})
				.catch((err) => console.log("GET USER TEAM ERROR", err))

	}

	//also sets Focus Team if get_team returns null
	const getTeams = (context, focusTeam) => {

		const teamrequest = {
			"purpose": "get_teams",
			"parameters": {}
		}

		return apicall.post("/arena/", teamrequest)
				.then((res) => {
					context.teamList = res.data

					if (!focusTeam) {
						const randomTeamIndex = Math.floor(Math.random() * res.data.length)
						focusTeam = res.data[randomTeamIndex].abbreviation;
						context.focusTeam = focusTeam;
						context.focusTeamData = res.data.filter(d => d.abbreviation === focusTeam)[0]
					}

				})
				.catch((error) => Promise.reject(error));

	}

	//calls getUserTeam and getTeams to trigger promise cascade in mounted()
	const getSchedule = (context) => {

		const schedrequest = {
			"purpose": "get_schedule",
			"parameters": {
				"show_all": 1
			}
		}

		return getUserTeam(context).then((focusTeam) => {
			return getTeams(context, focusTeam).then(() => {
				return apicall.post('/arena/', schedrequest)
						.then((res) => {
							context.dataError = false;
							return res.data;
						})
						.catch(() => {
							context.dataError = true
							return [{error: true}]
						})
			})
		})
	}

	const processSchedule = (teamlist, rawschedule) => {
		let schedule = {};
		console.log("TEAMLIST", teamlist)
		console.log("RAWSCHEDULE", rawschedule)
		teamlist.forEach(team => {
			let teamschedule = rawschedule.reduce((acc, d) => {
				let teams = d.teams.filter(t => t.abbreviation !== team.abbreviation);
				// console.log("POTENTIAL TEAMS", team.abbreviation, teams)
				if (teams.length === 1) {
					acc.push({
						...teams[0],
						round_start: new moment(d.round.starts, "YYYY-MM-DD"),
						round_end: new moment(d.round.ends, "YYYY-MM-DD"),
					});
				}
				return acc;
			}, []);
			// console.log(team.abbreviation, teamschedule)
			schedule[team.abbreviation] = teamschedule.sort((a, b) => a.round_start - b.round_start);
			console.log(team.abbreviation, schedule[team.abbreviation])
		})

		teamlist = teamlist.map(d => {
			return {...d, schedule: schedule[d.abbreviation]}
		})
		return teamlist;

	}


	export default {
		name: 'Arena',
		components: {
			Match,
			Bracket,
			Schedule,
			S3Image,
			Demo,
			DataTable,
			Spinner

		},
		data: function () {
			return {
				dashboardSection: 0,
				matchHistory: null,
				schedule: null,
				displayedSchedule: null,
				teamList: null,
				dataError: null,
				focusedDivision: 1,
				playoffs: false,
				matchHistoryFocusTeam: null,
				matchHistoryFocusTeamDisplayName: null,
				focusTeam: 'NNE-ME',
				focusTeamData: null,
				focusTeamOrgData: null,
				selectedOrgType: 'Facility',
				spinner: false,
        carouselPage: 3

			}
		},
		methods: {
      selectTeamFromSchedule: function(team, index) {
      	this.getMatchHistory(team)
            .then(() => {
            	  this.$refs.carousel.currentPage = 2;
            })

      },
			getMatchHistory: function (team) {
				this.matchHistoryFocusTeam = team;
				const request = {
					"purpose": "get_match_history",
					"parameters": {
						"team_abbreviation": team,
						"score_components": 1
					}
				}
				let _t = this
				_t.focusTeamOrgData = null
        try {
	        _t.organizationTableData(team)
        } catch (e) {
					console.error(e)
        }
				return apicall.post("/arena/", request)
						.then((res) => {
              console.log("arena request!!", res)
							//set focused team as team we are looking at
							_t.selectTeamFromList(team);
							_t.matchHistory = res.data.sort((a,b) => a.round.starts > b.round.starts ? 1 : -1);
						})
			},
			selectTeamFromList(team) {
				team = this.teamList.filter(d => d.abbreviation === team)
				if (team.length) {
					team = team[0]
				}
				else {
					return;
				}

				this.focusTeam = team.abbreviation; //this will be null if there is not team.
				this.focusTeamData = team;
			},
			organizationTableData(team) {
				this.spinner = true
				let request = {
					'purpose': "org_player_scores",
					'parameters': {
						'team_abbreviation': team
					}
				}
				let _t = this
				apicall.post('/arena/', request)
						.then((res) => {
							_t.focusTeamOrgData = res.data
						})
						.catch((err) => {
							console.log(err)
						})
			},
			orgTypeData(org_type) {

				if (this.focusTeamOrgData) {
					let raw = this.focusTeamOrgData.filter(d => d.type === org_type)
					let output = []
					raw.forEach(function (el) {
						const {name, impact, volume, score, round} = el;
						output.push({
              name,
              impact,
              volume,
              score,
              round,
              'link': '/dashboard/' + el.slug,
						})
					})
					this.spinner = false
					return output;
				} else {
					return null
				}

			}
		},
		watch: {
			focusedDivision: function () {
				const _t = this;
				_t.displayedSchedule = _t.schedule.filter(d => d.division === _t.focusedDivision)
			},
			matchHistoryFocusTeam: function () {
				const _t = this;
				_t.getMatchHistory(_t.matchHistoryFocusTeam)
						.then(() => {
							try {
								_t.matchHistoryFocusTeamDisplayName = _t.teamList.filter(d => d.abbreviation === _t.matchHistoryFocusTeam)[0].name
							} catch {
								_t.matchHistoryFocusTeamDisplayName = null;
							}
						});


			},
		},

		computed: {
			orgTypes: function () {
				if (this.focusTeamOrgData) {
					const unique = [...new Set(this.focusTeamOrgData.map(item => item.type))];
					return unique
					// return this.focusTeamOrgData.map((d)=>{d.organization__type})
				}

			},
		},
		mounted() {
			const _t = this;
			getSchedule(_t)
					.then((data) => {
						if (!data[0].error) {
							_t.schedule = processSchedule(_t.teamList, data);
							_t.focusedDivision = _t.focusTeamData.division;
							_t.displayedSchedule = _t.schedule.filter(d => d.division === _t.focusedDivision)

						}
					}).then(() => {
				return _t.getMatchHistory(_t.focusTeam)
			});
		}


	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">


  @import "../assets/less/palette.less";

  #documentation-trigger {
    position: fixed;
    right: 3vw;
    bottom: 4vh;
  }

  .subheader {

    /*<!--h4, h5, h6 {-->*/
    /*<!--color: @secondary;-->*/
    /*<!--}-->*/

    &.spread {
      display: flex;
      align-items: center;
      width: 90%;
      margin: 0 auto;
      justify-content: center;

      & > * {
        margin: 0 10px;
      }

    }

    &:not(:first-child) {
      margin-top: 10px;
    }

  }

  .slider-container {
    max-width: 80vw;
    margin: 0 auto;
  }

  .dashboard-card-container {
    margin-bottom: 1.5em;
  }

  .secondary {
    color: @secondary-3
  }

  .uk-slider-items:not(:first-child) {
    margin: 0 15vw;
  }

  .uk-slider-items:first-child {
    margin-right: 11%;
    margin-left: 5%;
  }

  .dot-nav-wrapper {
    margin: 1em auto;
    display: flex;
    justify-content: center;
  }

  .match-wrapper {
    display: flex;
    justify-content: center;
  }

  .bracket-wrapper {
    overflow-x: scroll;
  }

  /*.base-wrapper {*/
  /*background: url("https://wageup-media.s3.amazonaws.com/arena_background_one.jpg") no-repeat center center fixed;*/
  /*-webkit-background-size: cover;*/
  /*-moz-background-size: cover;*/
  /*-o-background-size: cover;*/
  /*background-size: cover;*/
  /*}*/

</style>
